import React from 'react';


type Props = {
    classNameContainer?: string,
    children?: JSX.Element | JSX.Element[],
    point: number,
    classNamePoint?: string
}

const JScoreCounter =({classNameContainer, children, point, classNamePoint}: Props) => {


    return (
        <div className={classNameContainer}>
            {children}
            <p className={classNamePoint}>{point}</p>
        </div>
    );
};

export { JScoreCounter };
